import { map, isEmpty } from 'underscore';

export const dataProperties = {
  videoUrl: 'Url',
  videoSize: 'videoSize',
  videoWidth: 'Width',
  videoHeight: 'Height',
  videoDescription: 'Description',
  videoCanPlay: 'isUrlValid',
};

export const getDataFromConfig = (videoConfig) => {
  if (isEmpty(videoConfig)) {
    return {};
  }

  return {
    videoUrl: videoConfig[dataProperties.videoUrl],
    videoSize: videoConfig[dataProperties.videoSize],
    videoWidth: videoConfig[dataProperties.videoWidth],
    videoHeight: videoConfig[dataProperties.videoHeight],
    videoDescription: videoConfig[dataProperties.videoDescription],
    videoCanPlay: videoConfig[dataProperties.videoCanPlay],
  };
};

export const VideoSize = {
  SMALL: _TL_('Small'),
  MEDIUM: _TL_('Medium'),
  LARGE: _TL_('Large'),
};

export const VideoSize2Px = {
  [VideoSize.SMALL]: { width: 640, height: 360 },
  [VideoSize.MEDIUM]: { width: 854, height: 480 },
  [VideoSize.LARGE]: { width: 1280, height: 720 },
};

const optionStylesProp = {
  field: {
    fontWeight: 400,
    padding: 0,
  },
};

export const videoSizeOption = map(VideoSize, item => (
  {
    key: item,
    text: item,
    styles: optionStylesProp,
  }
));

export const KeyBoardTypingDebounceTime = 500;

export const DescriptionHardLimit = 500;
